function validateIP (rule, value, callback) {
  const ipPattern = /^(\d{1,3}\.){3}\d{1,3}$/
  if (!value) {
    return callback(new Error('服务器IP不能为空'))
  }
  if (!ipPattern.test(value)) {
    return callback(new Error('请输入有效的IP地址'))
  }
  callback()
}

export { validateIP }
